import {combineLatest} from 'rxjs';
import {filter, map, startWith} from 'rxjs/operators';
import {currenciesCurrencyCache$} from '@/config';
import {fiat$} from '@/state/fiat';
import {indexPricesCache$} from '@/price-index/price-index';
import {spotWalletData$} from '@/spot-wallets/spot-wallets';
import {calcTotalAssets} from '@/assets/calc';
import type {AssetEntity, Assets} from '@/types';

export const spotAssets$ = spotWalletData$.pipe(
  map(({wallets}) => wallets.map((wallet) => <AssetEntity>{currency: wallet.currency, valueEv: wallet.totalBalanceEv})),
  startWith([])
);

export const spotTotalAssets$ = combineLatest([spotAssets$, indexPricesCache$, currenciesCurrencyCache$, fiat$]).pipe(
  map(([spotAssets, indexPricesCache, currencies, fiat]) =>
    calcTotalAssets(spotAssets, indexPricesCache, currencies, fiat)
  ),
  filter<Assets>(Boolean)
);
